import { render, staticRenderFns } from "./WarehouseByTransactionsReport.vue?vue&type=template&id=3b4683d9&"
import script from "./WarehouseByTransactionsReport.vue?vue&type=script&lang=ts&"
export * from "./WarehouseByTransactionsReport.vue?vue&type=script&lang=ts&"
import style0 from "./WarehouseByTransactionsReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports